import StageLoading from './styled';

export default StageLoading;
